import axios from 'axios';
import { apiUrl } from 'services/apiBaseUrl';

function downloadBase64File({ base64, mimeType, filename }) {
  const binary = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
  const blob = new Blob([binary], { type: mimeType });
  const fname = filename;
  const dlUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = dlUrl;
  a.download = fname;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(dlUrl);
}

/**
 * All signed signers for a signature request (one password-protected ZIP, folder per EV-*).
 * @param {string} requestId - SR-… signature request id (also OmmnioDocumentId in PDF Custom properties)
 * @param {string} tokenHash
 * @returns {Promise<{ filename: string, password: string }>}
 */
export async function downloadSuperadminRequestEvidenceBundle(requestId, tokenHash) {
  const url = apiUrl(`/v1/ommniosign/admin/requests/${encodeURIComponent(requestId)}/export`);
  const res = await axios.post(
    url,
    {},
    {
      headers: {
        Authorization: `Bearer ${tokenHash}`,
      },
      timeout: 300000,
    },
  );
  const payload = res.data?.data;
  if (!payload?.zipBase64 || !payload?.password) {
    const err = new Error('Unexpected response from server');
    err.code = 'UNEXPECTED_RESPONSE';
    throw err;
  }
  const fname = payload.filename || `signature-request-${requestId}-evidence-bundle.zip`;
  downloadBase64File({
    base64: payload.zipBase64,
    mimeType: 'application/zip',
    filename: fname,
  });

  return {
    filename: fname,
    password: payload.password,
  };
}

/**
 * All signed signers for a chat message (one password-protected ZIP, folder per EV-*).
 * @param {string} messageId - Mongo message _id
 * @param {string} tokenHash
 * @returns {Promise<{ filename: string, password: string }>}
 */
export async function downloadSuperadminMessageEvidenceBundle(messageId, tokenHash) {
  const url = apiUrl(`/v1/ommniosign/admin/messages/${encodeURIComponent(messageId)}/export`);
  const res = await axios.post(
    url,
    {},
    {
      headers: {
        Authorization: `Bearer ${tokenHash}`,
      },
      timeout: 300000,
    },
  );
  const payload = res.data?.data;
  if (!payload?.zipBase64 || !payload?.password) {
    const err = new Error('Unexpected response from server');
    err.code = 'UNEXPECTED_RESPONSE';
    throw err;
  }
  const fname = payload.filename || `message-${messageId}-evidence-bundle.zip`;
  downloadBase64File({
    base64: payload.zipBase64,
    mimeType: 'application/zip',
    filename: fname,
  });

  return {
    filename: fname,
    password: payload.password,
  };
}

/**
 * @param {unknown} err - axios error
 * @returns {string}
 */
export function getSuperadminEvidenceExportErrorMessage(err) {
  return (
    err.response?.data?.data?.error ||
    err.response?.data?.error ||
    (typeof err.message === 'string' ? err.message : null) ||
    'Error'
  );
}
